// extracted by mini-css-extract-plugin
module.exports = {"section":"IQ9ByHhoMABHfQO0FNbwM","container":"_1WLAmXK-8VJ6Th__-IWnDr"};